/*
 * @Description: 单位会话接口
 * @Date: 2026-09-23
 */
import service from '@/utils/request'

// 单位会话列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationOrgSession/page',
    data: params
  })

// 企业名称（下拉）
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })
